<template>
  <div class="basic-article-info-box height_fill" @mouseenter="module_isHover(true)" @mouseleave="module_isHover(false)"
       :data-device="getDevice" ref="basic_product_detail_index">
    <!--<div class="tooptipPart" v-if="isHover">-->
    <div class="tooptipPart">
      <my_edit_btn :module="module" :title="$t('widgets_basic_article_classification_index_336')"></my_edit_btn>
      <my_edit_btn :module="module" tabName="animation" :title="$t('widgets_basic_article_classification_edit_330')" v-if="isPc"></my_edit_btn>
      <!--<my_edit_btn cover-click></my_edit_btn>-->
      <div class="my_edit_btn  lineControl styleContent" @click="edit" v-if="isPc">
        <span class="el-icon-edit-outline" :title="$t('widgets_basic_article_info_index_354')"></span>
      </div>
      <!--<my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>-->
    </div>
    <div>
      <div class="module_wrap J_project_sort_handle">
        <div class="module_content">
          <div class="view_pattern_pc"
               v-if="$store.state.app.view_pattern === 'pc' && pc_widgets_infor.moduleStyle!==1">
            <div v-if="pc_widgets_infor.moduleStyle === 0 || pc_widgets_infor.moduleStyle === 3"
                 :class="['moduleStyle moduleStyle0','module-style-'+pc_widgets_infor.moduleStyle]">
              <div class="product_detail_wrap">
                <div class="product_detail_left_content">
                  <div class="detail_inner_wrap">
                    <div class="magnifier detail_big_pic_content" id="magnifier">
                      <div class="magnifier-container" id="magnifier-container">
                      <div class="images-cover" id="mask">
                        <img class="detail_big_pic" v-if="album.length === 0" src="/static/image/noimage.jpg">
                        <img
                          v-else
                          :src="album[showImgIndex]"
                          class="detail_big_pic"
                          @click="imgUpdate"
                        />
                      </div>
                      <div class="move-view"></div>
                    </div>
                    <div class="magnifier-view"></div>
                    </div>
                    <div class="detail_small_pic_wrap" v-if="album.length > 0">
                      <i class="iconfont icon-jiantouzuo" v-if="album.length >= 5" @click="swiper_prev"></i>
                      <div class="jz_scroll_wrap">
                        <swiper ref="mySwiper" class="list_box"
                                :options="swiperOption">
                          <swiper-slide
                            v-for="(item, index) in album"
                            :key="index"
                            @mouseenter.native="change_showImgIndex(index)"
                          >
                            <img
                              class="position_center_middle"
                              :src="item"
                              :data-active="showImgIndex === index"
                            />
                          </swiper-slide>
                        </swiper>
                      </div>
                      <i class="iconfont icon-jiantouyou" v-if="album.length >= 5" @click="swiper_next"></i>
                    </div>
                  </div>
                </div>
                <div class="product_detail_right_content">
                  <div class="detail_title_wrap">
                    <span class="detail_main_title" :style="titleStyle">{{ infoData.title }}</span>
                    <div class="detail_func_wrap" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
                      <div class="detail_share" v-if="$store.state.app.language === 'zh-cn'">
                        <my_share_render :share-type="pc_widgets_infor.shareType"
                                         v-if="pc_widgets_infor.share === 'open'"></my_share_render>
                      </div>
                      <div class="detail_share" v-if="$store.state.app.language !== 'zh-cn'">
                        <my_share_render :share-type="pc_widgets_infor.enShareType"
                                         v-if="pc_widgets_infor.share === 'open'"></my_share_render>
                      </div>
                    </div>
                  </div>
                  <div class="detail_content detail-summary-content" v-html="infoData.summary"></div>
                  <div class="detail_other_message">
                    <div class="detail_other" v-for="item in infoParams" :key="item.id">
                      <span class="detail_title">{{ item.title }}：</span>
                      <span class="detail_value">{{ item.value }}</span>
                    </div>
                  </div>
                  <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
                    <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
                      v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
                    <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
                      v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="pc_widgets_infor.moduleStyle === 1" class="moduleStyle moduleStyle1">
              <div class="product_detail_wrap">
                <div class="product_detail_right_content">
                  <div class="detail_title_wrap">
                    <span class="detail_main_title" :style="titleStyle">{{ infoData.title }}</span>
                    <div class="detail_func_wrap" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
                      <div class="detail_share"
                           v-if="pc_widgets_infor.share === 'open' && $store.state.app.language === 'zh-cn'">
                        <my_share_render :share-type="pc_widgets_infor.shareType"
                                         v-if="pc_widgets_infor.share === 'open'"></my_share_render>
                      </div>
                      <div class="detail_share"
                           v-if="pc_widgets_infor.share === 'open' && $store.state.app.language !== 'zh-cn'">
                        <my_share_render :share-type="pc_widgets_infor.enShareType"
                                         v-if="pc_widgets_infor.share === 'open'"></my_share_render>
                      </div>
                    </div>
                  </div>
                  <div class="detail_content detail-summary-content" v-html="infoData.summary"></div>
                  <div class="detail_other_message">
                    <div class="detail_other" v-for="item in infoParams" :key="item.id">
                      <span class="detail_title">{{ item.title }}：</span>
                      <span class="detail_value">{{ item.value }}</span>
                    </div>
                  </div>
                  <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
                    <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
                      v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
                    <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
                      v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="pc_widgets_infor.moduleStyle === 2" class="moduleStyle moduleStyle2">
              <div class="product_detail_wrap">
                <div class="product_detail_left_content">
                  <div class="detail_inner_wrap">
                    <div class="detail_small_pic_wrap">
                      <div class="jz_scroll_wrap">
                        <ul class="detail_small_pic_lists">
                          <li class="detail_small_pic_list" v-if="album.length === 0">
                            <img class="position_center_middle" src="/static/image/noimage.jpg"/>
                          </li>
                          <li class="detail_small_pic_list" v-else v-for="(item, index) in album" :key="index">
                            <img class="position_center_middle" :src="item" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="product_img_radio" :style="imgRadioCSS">
                  <div
                    class="product_img_radio_item_wrap"
                    v-for="(item, index) in album"
                    :key="index"
                    @click="scroll_dot(index)"
                  >
                    <div class="product_img_radio_item" :data-active="dotIndex === index"></div>
                  </div>
                </div>
                <div class="product_detail_right_content" :style="rightContentCSS">
                  <div class="detail_title_wrap">
                    <span class="detail_main_title" :style="titleStyle">{{ infoData.title }}</span>
                    <div class="detail_func_wrap" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
                      <div class="detail_share"
                           v-if="pc_widgets_infor.share === 'open' && $store.state.app.language === 'zh-cn'">
                        <my_share_render :share-type="pc_widgets_infor.shareType"
                                         v-if="pc_widgets_infor.share === 'open'"></my_share_render>
                      </div>
                      <div class="detail_share"
                           v-if="pc_widgets_infor.share === 'open' && $store.state.app.language !== 'zh-cn'">
                        <my_share_render :share-type="pc_widgets_infor.enShareType"
                                         v-if="pc_widgets_infor.share === 'open'"></my_share_render>
                      </div>
                    </div>
                  </div>
                  <div class="detail_content detail-summary-content" v-html="infoData.summary"></div>
                  <div class="detail_other_message">
                    <div class="detail_other" v-for="item in infoParams" :key="item.id">
                      <span class="detail_title">{{ item.title }}：</span>
                      <span class="detail_value">{{ item.value }}</span>
                    </div>
                  </div>
                  <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
                    <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
                      v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
                    <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
                      v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="pc_widgets_infor.moduleStyle === 4"
                 class="moduleStyle moduleStyle4 module-style-4">
              <div class="product_detail_wrap">
                <div class="product_detail_left_content">
                  <div class="detail_inner_wrap">
                   <div class="magnifier detail_big_pic_content" id="magnifier">
                      <div class="magnifier-container" id="magnifier-container">
                          <div class="images-cover" id="mask">
                            <img class="detail_big_pic" v-if="album.length === 0" src="/static/image/noimage.jpg">
                            <img
                              v-else
                              :src="album[showImgIndex]"
                              class="detail_big_pic"
                              @click="imgUpdate"
                            />
                          </div>
                        <div class="move-view"></div>
                      </div>
                      <div class="magnifier-view"></div>
                    </div>
                    <div class="detail_small_pic_wrap" v-if="album.length > 0">
                      <i class="iconfont icon-jiantouzuo" v-if="album.length >= 5" @click="swiper_prev"></i>
                      <div class="jz_scroll_wrap">
                        <swiper ref="mySwiper" class="list_box my-swiper-4"
                                :options="verticalSwiperOption">
                          <swiper-slide
                            v-for="(item, index) in album"
                            :key="index"
                            @mouseenter.native="change_showImgIndex(index)"
                          >
                            <img
                              class="position_center_middle"
                              :src="item"
                              :data-active="showImgIndex === index"
                            />
                          </swiper-slide>
                        </swiper>
                      </div>
                      <i class="iconfont icon-jiantouyou" v-if="album.length >= 5" @click="swiper_next"></i>
                    </div>
                  </div>
                </div>
                <div class="product_detail_right_content">
                  <div class="detail_title_wrap">
                    <div class="my-title-wrapper" :style="{...titleStyle,fontSize:0}">
                      <span class="detail_main_title" :style="titleStyle">{{ infoData.title }}</span>
                      <div class="detail_func_wrap" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
                        <div class="detail_share" v-if="$store.state.app.language === 'zh-cn'">
                          <my_share_render :share-type="pc_widgets_infor.shareType"
                                           v-if="pc_widgets_infor.share === 'open'"></my_share_render>
                        </div>
                        <div class="detail_share" v-if="$store.state.app.language !== 'zh-cn'">
                          <my_share_render :share-type="pc_widgets_infor.enShareType"
                                           v-if="pc_widgets_infor.share === 'open'"></my_share_render>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="detail_content detail-summary-content" v-html="infoData.summary"></div>
                  <div class="detail_other_message">
                    <div class="detail_other" v-for="item in infoParams" :key="item.id">
                      <span class="detail_title">{{ item.title }}：</span>
                      <span class="detail_value">{{ item.value }}</span>
                    </div>
                  </div>
                  <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
                    <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
                      v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
                    <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
                      v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail_pagination_wrap"
                 v-if="pc_widgets_infor.showContent.find(item => item === 'firstAndNext')">
              <div v-if="infoData.prevId" class="nav-btn-wrapper nav-btn-wrapper-left" @click="prev_page">
                <div class="btn prev" :style="infoData.prevId === '' ? 'color: #999' : ''">{{ getLang($t('widgets_basic_article_info_index_355'))}}</div>
                <span class="nav-btn-title" :title="infoData.prevTitle">{{ infoData.prevTitle }}</span>
              </div>
              <div v-if="infoData.nextId" class="nav-btn-wrapper nav-btn-wrapper-right" @click="next_page">
                <div class="btn next" :style="infoData.nextId === '' ? 'color: #999' : ''">{{ getLang($t('widgets_basic_article_info_index_356'))}}</div>
                <span class="nav-btn-title" :title="infoData.nextTitle">{{ infoData.nextTitle }}</span>
              </div>
            </div>
          </div>
          <div class="view_pattern_mb" v-if="$store.state.app.view_pattern === 'mb'">
            <div class="product_detail_wrap">
              <template v-if="pc_widgets_infor.moduleStyle !== 1">
                <div class="detail_big_pic_content" v-if="album.length === 0">
                  <img class="detail_big_pic" src="/static/image/noimage.jpg">
                </div>
                <div class="product_detail_left_content" v-else>
                  <swiper
                    v-if="showMbSwiper"
                    ref="mb_swiper"
                    class="list_box"
                    :options="mbSwiperOption"
                    @slideChange="slide_change"
                  >
                    <swiper-slide v-for="(item, index) in album" :key="index">
                      <div class="detail_big_pic_content">
                        <img class="position_center_middle" :src="item"/>
                      </div>
                    </swiper-slide>
                  </swiper>
                  <div class="swiper-pagination">{{ mbSwiperPage }} / {{ album.length }}</div>
                </div>
                <div class="product_detail_right_content">
                  <div class="detail_title_wrap">
                    <span class="detail_main_title" :style="titleStyle">{{ infoData.title }}</span>
                    <div class="detail_func_wrap" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
                      <div class="detail_share"
                           v-if="pc_widgets_infor.share === 'open' && $store.state.app.language === 'zh-cn'">
                        <my_share_render :share-type="pc_widgets_infor.shareType"
                                         v-if="pc_widgets_infor.share === 'open'"></my_share_render>
                      </div>
                      <div class="detail_share"
                           v-if="pc_widgets_infor.share === 'open' && $store.state.app.language !== 'zh-cn'">
                        <my_share_render :share-type="pc_widgets_infor.enShareType"
                                         v-if="pc_widgets_infor.share === 'open'"></my_share_render>
                      </div>
                    </div>
                  </div>
                  <div class="detail_summary_content" v-if="infoData.summary !== ''" v-html="infoData.summary"></div>
                  <div class="detail_other_message" @click="isShowMessage = true" v-if="infoParams.length > 0">
                    <div class="detail_other">
                      <span class="detail_other-prefix">{{$t('widgets_basic_article_info_index_357')}}</span>
                      <span class="detail_title">{{ infoParams[0].title }}：</span>
                      <span class="detail_value">{{ infoParams[0].value }}</span>
                      <span class="detail_icon">
                <i class="iconfont icon-jiantouyou"></i>
              </span>
                    </div>
                  </div>
                  <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
                    <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
                      v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
                    <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
                      v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
                  </div>
                  <div class="detail_other_message_mobi_wrap" :data-active="isShowMessage" v-if="infoParams.length > 0">
                    <div class="detail_other_panel_bg" @click="isShowMessage = false"></div>
                    <div class="detail_other_content">
                      <div class="detail_other_message_mobi">
                        <div class="detail_other_panel_title">{{$t('widgets_basic_article_info_index_358')}}</div>
                        <div class="detail_other_scroll_wrap">
                          <div class="detail_other" v-for="item in infoParams" :key="item.id">
                            <span class="detail_title">{{ item.title }}：</span>
                            <span class="detail_value">{{ item.value }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="detail_other_message_mobi_btn" @click="isShowMessage = false">{{$t('view_login_index_37')}}</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="module_content_detail module_news_detail_content" projectid="2">
            <div class="news_detail_header" v-if="pc_widgets_infor.moduleStyle===1">
              <h1 class="news_detail_title" :style="titleStyle">{{ infoData.title }}</h1>
              <div class="detail_summary_content detail-summary-content" v-html="infoData.summary" v-if="infoData.summary !== ''"></div>
              <div class="news_detail_info"
                   v-if="(pc_widgets_infor.showContent.find(item => item === 'date')) || (pc_widgets_infor.showContent.find(item => item === 'author') && infoData.author !== '')">
                <div class="news_detail_info_left">
                  <span class="news_detail_info_item" v-if="pc_widgets_infor.showContent.find(item => item === 'date')">{{
                      infoData.date
                    }}</span>
                  <span class="news_detail_info_item"
                        v-if="pc_widgets_infor.showContent.find(item => item === 'author') && infoData.author !== ''">{{
                      infoData.author
                    }}</span>
                </div>
                <div class="news_detail_info_right"></div>
              </div>
            </div>
            <div class="news_detail_content_wrap">
              <div class="news_detail_content ul-set" v-html="infoData.content"></div>
            </div>
            <div class="news_detail_divice_line"></div>
            <div class="news_content_footer" v-if="pc_widgets_infor.moduleStyle===1">
              <div class="news_info_footer_line">
                <div class="news_info_soruece_detail">
                  <span class="news_detail_info_item news_detail_info_source"
                        v-if="pc_widgets_infor.showContent.find(item => item === 'source') && infoData.source !== ''">{{
                      infoData.source
                    }}</span>
                  <span class="news_detail_info_item" v-if="pc_widgets_infor.showContent.find(item => item === 'url')">
                    <a :href="$t('widgets_basic_article_info_index_359')" target="_blank" class="news_detail_info_href">{{$t('widgets_basic_article_info_index_359')}}</a>
                  </span>
                </div>
                <my_share_render :share-type="pc_widgets_infor.shareType"
                                 v-if="
                $store.state.app.language === 'zh-cn'
                && pc_widgets_infor.share === 'open'
                && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
                <my_share_render :share-type="pc_widgets_infor.enShareType"
                                 v-if="
                $store.state.app.language !== 'zh-cn'
                && pc_widgets_infor.share === 'open'
                && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
              </div>
              <div class="news_detail_group_list">
                <a :href="typeHref" target="_blank" class="news_belong_group"
                   v-if="pc_widgets_infor.showContent.find(item => item === 'type')">{{ infoData.type }}</a>
              </div>
              <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
                <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
                  v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
                <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
                  v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
              </div>
            </div>
            <div class="news_detail_footer">
              <div class="news_pagenation_wrap"
                   v-if="$store.state.app.view_pattern === 'mb' || pc_widgets_infor.moduleStyle===1">
                <div class="news_pagenation news_pagenation_prev" v-if="infoData.prevId">
              
                  <span class="pagenation_title">{{ getLang($t('widgets_basic_article_info_index_355'))}}:</span>
                  <span @click="prev_page" class="pagenation_link">{{ infoData.prevTitle }}</span>
                  <!-- <a hidefocus="true" :href="'#/article?id=' + infoData.prevId"
                     class="pagenation_link">{{ infoData.prevTitle }}</a> -->
                </div>
                <div class="news_pagenation news_pagenation_next" v-if="infoData.nextId">
                  <span class="pagenation_title">{{ getLang($t('widgets_basic_article_info_index_356'))}}:</span>
                  <span @click="next_page" class="pagenation_link">{{ infoData.nextTitle }}</span>
                  <!-- <a hidefocus="true" :href="'#/article?id=' + infoData.nextId"
                     class="pagenation_link">{{ infoData.nextTitle }}</a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <basic_addArticle
      :article-type="type"
      :edit-id="id"
      v-if="showEditArticle"
      @closed="closeEditArticle"
      @submit_sure="getArticle"
    ></basic_addArticle>

    <!-- 图片放大 -->
    <img-scale :show-pop.sync="img_scale_show" :img-url="album[showImgIndex]" :video-update="album"></img-scale>

  </div>
</template>

<script>
import i18n from '../../language/index'

import {getArticleEdit, getPreNext} from './../../api/app.js'
import my_share_render from './../../components/my_share/render'
import imgScale from '@/components/img_scale'
export default {
  name: 'basic_article_info',
  data() {
    return {
      img_scale_show: false,
      video_load_status: false,
      id: '',
      isHover: false,
      type: 1,
      infoData: {
        title: '',
        date: '',
        type: '',
        typeId: '',
        _type: '',
        content: '',
        source: '',
        author: '',
        prevTitle: '',
        prevId: '',
        nextTitle: '',
        nextId: '',
        summary: ''
      },
      infoParams: [],
      showImgIndex: 0,
      dotIndex: 0,
      album: [],
      showEditArticle: false,
      swiperOption: {
        direction: "horizontal",
        slidesPerView: 5,
        slidesPerGroup: 1
      },
      verticalSwiperOption: {
        direction: "vertical",
        slidesPerView: 5,
        slidesPerGroup: 1,
      },
      showContentOptions: [{
        label: i18n.t('widgets_basic_article_info_edit_346'),
        value: 'date'
      }, {
        label: i18n.t('widgets_basic_article_info_edit_347'),
        value: 'author'
      }, {
        label: i18n.t('widgets_basic_article_info_edit_348'),
        value: 'type'
      }, {
        label: i18n.t('widgets_basic_article_info_edit_349'),
        value: 'firstAndNext'
      }, {
        label: i18n.t('widgets_basic_article_info_edit_350'),
        value: 'source'
      }, {
        label: i18n.t('widgets_basic_article_info_edit_351'),
        value: 'click'
      }],
      mbSwiperOption: {
        watchOverflow: true,
        loop: true
      },
      mbSwiperPage: 1,
      showMbSwiper: false,
      rightContentCSS: {
        top: '77px',
        left: '59.8413%',
        width: '40%',
        position: 'absolute'
      },
      imgRadioCSS: {
        position: 'absolute',
        top: '262px',
        left: '12px'
      },
      isShowMessage: false,
      pre_detail: null, // 上一个
      next_detail: null,// 下一个
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    widgets_infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
    },
    listArr() {
      return this.module.data.listArr
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    titleStyle() {
      const style = {}
      const titleStyle = this.pc_widgets_infor.titleStyle
      const font = titleStyle[titleStyle.radio_val]
      style.fontSize = font.fontSize + 'px'
      style.fontFamily = font.fontFamily
      style.color = font.fontColor
      style.fontStyle = font.fsItalics
      style.fontWeight = font.fsWeight
      style.textDecoration = font.fontUnderline
      style.textAlign = font.textAlign
      if (titleStyle.radio_val === 'custom') {
        if(titleStyle.custom.fontSize > 40){
          style.lineHeight = 1.2
        }
      }
      return style
    },
    getDevice() {
      return this.$store.state.app.view_pattern
    },
    typeHref() {
      if (this.infoData._type === 1) return '#/article_index?typeId=' + this.infoData.typeId // 新闻
      if (this.infoData._type === 2) return '#/help_index?typeId=' + this.infoData.typeId // 帮助
      if (this.infoData._type === 3) return '#/case_index?typeId=' + this.infoData.typeId // 案例
    },
    isPc() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    is_road_type() {
      return this.$store.getters['app/is_road_type']
    },
  },
  components: {
    my_share_render
  },
  watch: {
    'module.data.pc_widgets_infor': {
      handler(val, oldVal) {
      },
      deep: true
    },
    'module.data.listArr': {
      handler(val, oldVal) {
      },
      deep: true
    },
    '$store.state.app.view_pattern'(val) {
      this.$nextTick(() => {
        if (val === 'mb') {
          this.mbSwiperPage = 1
          setTimeout(() => {
            this.showMbSwiper = true
          }, 300)
        } else {
          this.showMbSwiper = false
        }
        // this.scroll_change()
      })
    },
    'pc_widgets_infor.moduleStyle'(val) {
      setTimeout(() => {
        if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
          let direction = val === 4 ? 'vertical' : 'horizontal'
          this.$refs.mySwiper.swiper.changeDirection(direction, true)
        }
      }, 100)
    },
    'pc_widgets_infor.showContent': {
      handler(val) {
        this.getInfoParams(val)
      },
      deep: true
    },
  },
  methods: {
    imgUpdate(){ //点击图片进行放大处理的显示
      this.img_scale_show = true
    },
    module_isHover(val) {
      this.isHover = val
    },
    getArticle() {
      if(!this.id) {
        return
      }
      getArticleEdit({
        id: this.id
      }).then(res => {
        if (res.code !== 200) return this.$message.error(res.message)
        this.type = res.data.info.type
        this.infoData.title = res.data.info.title
        this.infoData.content = res.data.info.content
        this.infoData.type = res.data.info.category_name
        this.infoData.date = this.$moment(res.data.info.auto_issue * 1000).format('YYYY-MM-DD HH:mm:ss')
        this.infoData.source = res.data.info.source
        this.infoData.author = res.data.info.author
        this.infoData.typeId = res.data.info.category_id
        this.infoData._type = res.data.info.type
        this.infoData.summary = this.replaceBr(res.data.info.summary)
        this.infoData.click = res.data.info.click
        if (res.data.info.album) {
          this.album = res.data.info.album
        }
        this.getInfoParams(this.pc_widgets_infor.showContent)
      })
      let module_name = ''
      if (this.$route.name === 'article') module_name = 'article'
      if (this.$route.name === 'help') module_name = 'help'
      if (this.$route.name === 'case') module_name = 'case'
      if (module_name !== '') {
        getPreNext({
          id: this.id,
          module_name
        }).then(res => {
          if (res.code !== 200) return this.$message.error(res.message)
          this.infoData.prevTitle = (res.data.pre || {}).title
          this.infoData.prevId = (res.data.pre || {}).id
          this.infoData.nextTitle = (res.data.next || {}).title
          this.infoData.nextId = (res.data.next || {}).id
          this.pre_detail=res.data.pre
          this.next_detail=res.data.next
        })
      }
    },
    edit() {
      this.showEditArticle = true
    },
    closeEditArticle() {
      this.showEditArticle = false
    },
    getInfoParams(paraList) {
      let infoParams = []
      paraList.map((item) => {
        if (this.infoData[item]) {
          infoParams.push({
            key: item,
            title: this.showContentOptions.find(op => op.value === item).label,
            value: this.infoData[item]
          })
        }
      })
      this.infoParams = infoParams
    },
    swiper_prev() {
      this.$refs.mySwiper.swiper.slidePrev()
      if (this.showImgIndex > 0) {
        this.showImgIndex--
      }
    },
    swiper_next() {
      this.$refs.mySwiper.swiper.slideNext()
      if (this.showImgIndex < this.album.length - 1) {
        this.showImgIndex++
      }
    },
    change_showImgIndex(index) {
      this.showImgIndex = index
    },
    scroll_dot(index) {
      let step = $('.product_detail_left_content .detail_small_pic_list').eq(0).width() + 36 // 36是marginTop
      let widgetDom = this.$refs.basic_product_detail_index
      let offsetTop = getTopByWindow(widgetDom)
      let contentScroll = offsetTop + step * index
      $(window).scrollTop(contentScroll)
    },
    prev_page() {
      if (this.infoData.prevId) {
        let query = {id: this.infoData.prevId}
        if(this.is_road_type)query.tag_id = this.pre_detail.tag_ids
        let name = this.$route.name
        if (this.$store.state.app.is_change) {
          this.$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
            confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
            cancelButtonText: i18n.t('view_public_topbar_11'),
            center: true,
            appendToBody: true
          }).then(() => {
            this.$store.state.main_dialog.main_dialog_isShow = false
            this.$router.push({
              name,
              query
              /* name: 'product',
              query: {id: this.prevPageID} */
            })
          }).catch(action => {
            console.log('取消弹窗')
          })
        } else {
          this.$store.state.main_dialog.main_dialog_isShow = false
          this.$router.push({
            name,
            query
            /* name: 'article',
            query: {id: this.infoData.prevId} */
          })
        }

      }
    },
    next_page() {
      if (this.infoData.nextId) {
        let query = {id: this.infoData.nextId}
        if(this.is_road_type)query.tag_id = this.next_detail.tag_ids
        let name = this.$route.name
        if (this.$store.state.app.is_change) {
          this.$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
            confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
            cancelButtonText: i18n.t('view_public_topbar_11'),
            center: true,
            appendToBody: true
          }).then(() => {
            this.$store.state.main_dialog.main_dialog_isShow = false
            this.$router.push({
              name,
              query
              /* name: 'product',
              query: {id: this.nextPageID} */
            })
          }).catch(action => {
            console.log('取消弹窗')
          })
        } else {
          this.$store.state.main_dialog.main_dialog_isShow = false
          this.$router.push({
            name,
            query
            /* name: 'article',
            query: {id: this.infoData.nextId} */
          })
        }
      }
    },
    slide_change() {
      this.mbSwiperPage = this.$refs.mb_swiper.swiper.realIndex + 1
    },
    replaceBr(str){
      return str.replace(/\n/g,"<br>")
    }
  },
  created() {
    if (typeof this.module.data.pc_widgets_infor.enShareType == 'undefined') {
      this.$set(this.module.data.pc_widgets_infor, 'enShareType', ['twitter','wechat','facebook','linkedin'])
    }
    if (typeof this.module.data.pc_widgets_infor.shareDisplayStyle == 'undefined') {
      this.$set(this.module.data.pc_widgets_infor, 'shareDisplayStyle', 'default')
    }
  },
  mounted() {
    this.id = Number(this.$route.query.id)
    if (this.id) this.getArticle()
    if (!this.id) {
      this.type = 1
      this.infoData.title = i18n.t('widgets_basic_article_info_index_362')
      this.infoData.content = i18n.t('widgets_basic_article_info_index_363')
      this.infoData.type = i18n.t('widgets_basic_article_info_index_364')
      this.infoData.date = '2020-02-02'
      this.infoData.source = ''
      this.infoData.author = i18n.t('widgets_basic_article_info_index_365')
      this.infoData.typeId = 1
      this.infoData._type = 1
    }

    // 强制更新标题样式默认值（版本控制，只执行一次）
    if (this.pc_widgets_infor.titleStyle && this.pc_widgets_infor.titleStyle.default && !this.pc_widgets_infor._styleVer2) {
      this.pc_widgets_infor.titleStyle.default.fontSize = 26
      this.pc_widgets_infor.titleStyle.default.fontColor = 'rgba(51,51,51,1)'
      this.pc_widgets_infor.titleStyle.default.fontFamily = 'Arial'
      this.pc_widgets_infor.titleStyle.default.fsWeight = '700'
      this.pc_widgets_infor.titleStyle.custom.fontSize = 26
      this.pc_widgets_infor.titleStyle.custom.fontColor = 'rgba(51,51,51,1)'
      this.pc_widgets_infor.titleStyle.custom.fontFamily = 'Arial'
      this.pc_widgets_infor.titleStyle.custom.fsWeight = '700'
      this.$set(this.pc_widgets_infor, '_styleVer2', 1)
    }

    // 兼容旧数据
    if (!this.pc_widgets_infor.moduleStyle && this.pc_widgets_infor.moduleStyle !== 0) {
      this.$set(this.pc_widgets_infor, 'moduleStyle', 1)
    }
    if (!this.pc_widgets_infor.showContentOptions) {
      this.$set(this.pc_widgets_infor, 'showContentOptions', this.showContentOptions)
    }

    // 判断平台，初始化swiper
    if (this.$store.state.app.view_pattern === 'mb') {
      this.mbSwiperPage = 1
      this.showMbSwiper = true
    } else {
      this.showMbSwiper = false
    }

  },
  components: {
    imgScale
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/magnifier.scss';
.basic-article-info-box {
  background: #fff;

  .jz_sys_module .J_project_sort_handle {
    cursor: auto;
  }

  [class*=faisco-icons] {
    font-family: icomoon !important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .module_content {
    position: relative;
    font-size: 14px;
  }

  .detail_share_tile {
    margin: 10px 0px;
  }

  .module_news_detail_content {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 0;
    line-height: 1;
    padding-bottom: 20px;
  }

  &[data-device='mb'] .news_detail_header {
    margin-bottom: 20px;
  }

  .news_detail_title {
    padding-bottom: 24px;
    padding-top: 24px;
    font-size: 24px;
    color: #333;
    font-family: Arial;
    font-weight: 700;
    line-height: 1.3;
  }

  .detail_summary_content {
    margin-bottom: 24px;
    word-wrap: break-word;
    line-height: 1.6;
    font-size: 16px;
    color: #333;
    font-family: Arial;
  }

  .news_detail_info {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 14px;
    color: #999;
    font-family: Arial;
    margin-bottom: 24px;
  }

  .news_detail_info_item {
    font-size: 14px;
    margin-right: 22px;
  }

  .news_detail_content_wrap {
    padding-top: 30px;
    border-top: 1px solid #ebebeb;
    margin-bottom: 30px;
  }

  .news_detail_content {
    font-size: 16px;
    color: #333;
    font-family: Arial;
    word-wrap: break-word;
    line-height: 2.8;
    &.ul-set{
      /deep/  {
        ol,li{
          list-style: decimal;
        }
        ul li{
          list-style: disc;
        }
      }
    }
  }

  .news_detail_divice_line {
    border-bottom: 1px dashed #efefef;
    margin-bottom: 26px;
  }

  .news_content_footer {
    box-sizing: border-box;
    margin-top: 26px;

    .detail_share_tile {
      display: flex;
    }
  }

  &[data-device='mb'] .news_content_footer {
    margin-top: 20px;
  }

  .news_info_footer_line {
    margin-bottom: 26px;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    width: 100%;
    white-space: nowrap;
    line-height: 1.5;
  }

  &[data-device='mb'] .news_info_footer_line {
    margin-bottom: 20px;
  }

  .news_info_soruece_detail {
    flex-grow: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 1;
    max-width: calc(100% - 50px);
  }

  .news_detail_info_item {
    font-size: 14px;
    margin-right: 22px;
  }

  &[data-device='mb'] .news_detail_info_item {
    font-size: 14px;
  }

  .news_detail_info_source {
    display: inline-block;
    max-width: 100%;
    margin-right: 0;
    padding-right: 25px;
    color: #999;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .news_detail_info_item {
    margin-right: 0;
    padding-right: 25px;
    max-width: 100%;
    box-sizing: border-box;
  }

  .news_detail_info_href {
    display: inline-block;
    max-width: 100%;
    color: #999;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .news_detail_group_list {
    margin-bottom: 50px;
  }

  &[data-device='mb'] .news_detail_group_list {
    margin-bottom: 20px;
  }

  .news_belong_group {
    display: inline-block;
    box-sizing: border-box;
    height: 25px;
    line-height: 23px;
    margin-right: 15px;
    padding: 0 10px;
    border: 1px solid #c7c7c7;
    border-radius: 3px;
    color: #6f6f6f;
    font-size: 14px;
  }

  .news_detail_footer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 70px;
  }

  &[data-device='mb'] .news_detail_footer {
    margin-top: 0;
    margin-bottom: 20px;
  }

  .news_pagenation_wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 0;
    color: #666;
  }

  .news_pagenation_wrap .news_pagenation:nth-child(2) {
    margin-top: 30px;
  }

  .pagenation_title {
    font-size: 14px;
    margin-right: 28px;
    color: #333;
  }

  .pagenation_link {
    font-size: 14px;
    color: #333;
  }

  // 新增需求：模块样式
  .view_pattern_pc {
    padding: 20px;

    .detail_pagination_wrap {
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      padding-top: 18px;

      .nav-btn-wrapper {
        cursor: pointer;
        display: flex;
        width: 50%;
        align-items: center;
      }

      .nav-btn-wrapper-left {
        padding-right: 20px;
      }

      .btn {
        box-sizing: border-box;
        display: inline-flex;
        width: 80px;
        height: 30px;
        line-height: 28px;
        text-align: center;
        border-radius: 15px;
        border: 1px solid #e9e9e9;
        cursor: pointer;
        justify-content: center;
        font-size: 14px;
        color: #333;
      }

      .nav-btn-title {
        flex: 1;
        padding-left: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        font-size: 14px;
        color: #333;
      }
    }

    .moduleStyle0, .moduleStyle4 {
      position: relative;
      font-size: 14px;

      .product_detail_wrap {
        width: 100%;
        font-size: 14px;

        .product_detail_left_content {
          width: 43.75%;
          float: left;

          .detail_inner_wrap {
            width: auto;
            margin-right: 4.8%;
            position: relative;

            .detail_big_pic_content {
              position: relative;
              box-sizing: border-box;
              width: 100%;
              padding-bottom: 100%;
              border: 1px solid #eee;

              .detail_big_pic {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              }
            }
          }

          .detail_small_pic_wrap {
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: 14px;

            .iconfont {
              position: absolute;
              width: 12px;
              cursor: pointer;

              &.icon-jiantouzuo {
                left: 0;
                margin-left: 2px;
              }

              &.icon-jiantouyou {
                right: 0;
                margin-right: 2px;
              }
            }

            .jz_scroll_wrap {
              width: 92%;
              display: inline-block;
              margin-left: 4%;
              margin-right: 4%;

              /deep/ .swiper-container {
                padding-bottom: 1px;
                padding-right: 1px;
              }

              .list_box {
                .swiper-wrapper {
                  .swiper-slide {
                    box-sizing: border-box;
                    position: relative;
                    font-size: 0;
                    padding-bottom: 17.2%;
                    padding-left: 17.2%;

                    .position_center_middle {
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                      border: 1px solid transparent;
                      object-fit: contain;
                      cursor: pointer;

                      &[data-active] {
                        border-color: var(--theme_color);
                      }
                    }
                  }
                }
              }
            }
          }

          .detail_pagination_wrap {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 18px;

            .btn {
              box-sizing: border-box;
              display: inline-block;
              width: 80px;
              height: 30px;
              line-height: 28px;
              text-align: center;
              border-radius: 15px;
              border: 1px solid #e9e9e9;
              cursor: pointer;
            }
          }
        }

        .product_detail_right_content {
          width: 56.25%;
          float: left;
          box-sizing: border-box;

          .detail_title_wrap {
            font-size: 20px;
            line-height: 40px;
            color: #333;
            word-break: break-word;
            margin-top: 10px;
            display: flex;
            align-items: center;

            .detail_main_title {
              min-width: calc(100% - 120px);
              padding-right: 20px;
              box-sizing: border-box;
              overflow: hidden;
              font-size: 20px;
              line-height: 40px;
              color: #333;
              word-break: break-word;
            }

            .detail_func_wrap {
              // line-height: 0;
              min-width: 120px;
              text-align: left;
              border-left: 1px solid #f0f0f0;
              padding-left: 19px;
              box-sizing: border-box;

              .detail_share {
                display: inline-block;
                font-size: 14px;
                color: #333;
                vertical-align: middle;
                text-align: center;
                cursor: pointer;

                /deep/ .jz_share_text {
                  .u-icon {
                    display: block;
                    width: 40px;
                    height: 20px;
                    line-height: 20px;
                    font-size: 24px;
                    text-align: center;
                    margin: 0 !important;
                  }
                }
              }
            }
          }

          .detail_content {
            margin-top: 6px;
            padding: 10px 10px 10px 0;
          }

          .detail_other_message {
            margin-left: 0px;
            margin-top: 6px;
            transition: margin-left 0.5s;

            .detail_other {
              border-bottom: none !important;
              line-height: 40px;

              .detail_title {
                font-size: 16px;
                color: #333;
              }

              .detail_value {
                font-size: 16px;
                color: #333;
                opacity: 0.9;
              }
            }
          }

          .product_button_wrap {
            display: flex;
            align-items: center;
            margin-top: 30px;
            padding-left: 0px;

            .product_advisory_btn {
              width: 200px;
              height: 42px;
              color: #fff;
              font-size: 15px;
              line-height: 42px;
              text-align: center;
              border-radius: 21px;
              background-color: var(--theme_color);
              transition: background-color .3s;
              // cursor: pointer;
              .icon-phonenew {
                font-size: 16px;
              }
            }
          }
        }
      }

      &.module-style-3 {
        .product_detail_wrap {
          .product_detail_left_content {
            float: right;
          }
        }
      }


    }

    .moduleStyle4 {
      &.module-style-4 {
        .product_detail_wrap {
          .product_detail_left_content {
            width: 100%;
            float: none;

            .detail_big_pic_content {
              width: 90%;
              height: 0;
              padding-bottom: 450px;
              float: left;
            }

            @media screen and (max-width: 1700px) {
              .detail_big_pic_content {
                width: 85%;
              }
            }

            @media screen and (max-width: 1200px) {
              .detail_big_pic_content {
                width: 80%;
              }
            }

            @media screen and (max-width: 900px) {
              .detail_big_pic_content {
                width: 70%;
              }
            }

            .detail_small_pic_wrap {
              width: 100px;
              height: 450px;
              display: inline-block;
              margin-top: 0;
            }

            .iconfont.icon-jiantouzuo {
              top: 0;
              left: 0;
              right: 0;
              margin-left: auto;
              margin-right: auto;
              transform: rotate(90deg);
            }

            .iconfont.icon-jiantouyou {
              left: 0;
              right: 0;
              margin-left: auto;
              margin-right: auto;
              transform: rotate(90deg);
              bottom: 0;
            }

            .jz_scroll_wrap {
              height: 400px;

              .list_box {
                height: 400px;
                margin-top: 25px;
                margin-bottom: 25px;
              }
            }
          }

          .product_detail_right_content {
            clear: both;
            width: 100%;
            margin-top: 15px;
          }
        }
      }
    }

    .moduleStyle1 {
      .product_detail_wrap {
        overflow: hidden;
        width: 100%;
        font-size: 14px;

        .product_detail_right_content {
          display: block;
          width: 100%;

          .detail_title_wrap {
            display: flex;
            align-items: flex-start;
            max-width: 100%;

            .detail_main_title {
              min-width: 0;
              font-size: 20px;
              color: #1a1a1a;
              white-space: normal;
              display: inline-block;
              padding-right: 20px;
            }

            .detail_func_wrap {
              border-left: 0;
              padding-left: 0;
              padding-top: 6px;

              .detail_share {
                display: inline-block;
                font-size: 14px;
                color: #333;
                vertical-align: middle;
                cursor: pointer;

                /deep/ .g-share-render-box {
                  .jz_share_text {
                    .u-icon {
                      display: block;
                      width: 40px;
                      height: 35px;
                      line-height: 20px;
                      font-size: 24px;
                      text-align: center;
                      margin: 0 !important;
                    }

                    .u-share_title {
                      display: none;
                    }
                  }

                  .jz_share_list {
                    right: auto;
                    left: -30px;
                    text-align: center;

                    &::before {
                      right: auto;
                      left: 45px;
                    }
                  }
                }
              }
            }
          }

          .detail_content {
            margin-top: 6px;
            padding: 10px 0;
          }

          .detail_other_message {
            margin-left: 0px;
            margin-top: 6px;
            display: flex;
            flex-wrap: wrap;
            transition: margin-left 0.5s;

            .detail_other {
              width: 50%;
              padding: 13px 0;
              display: flex;
              padding-right: 15px;
              line-height: 30px;
              box-sizing: border-box;
              border-bottom: 1px solid rgba(245, 245, 245, 1);

              .detail_title {
                font-size: 14px;
                font-weight: 700;
                color: #4c4c4c;
                display: block;
                width: 120px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                box-sizing: border-box;
                padding: 0 0px;
              }

              .detail_value {
                font-size: 14px;
                color: #666;
                width: calc(100% - 120px);
              }
            }
          }

          .product_button_wrap {
            display: flex;
            align-items: center;
            margin-top: 30px;

            .product_advisory_btn {
              width: 200px;
              height: 42px;
              color: #fff;
              font-size: 15px;
              line-height: 42px;
              text-align: center;
              border-radius: 21px;
              background-color: var(--theme_color);
              transition: background-color .3s;
              // cursor: pointer;
              .icon-phonenew {
                font-size: 16px;
              }
            }
          }

          .detail_pagination_wrap {
            margin-top: 30px;
            margin-left: 10px;

            .btn {
              box-sizing: border-box;
              display: inline-block;
              margin: 0 6px;
              width: 80px;
              height: 30px;
              line-height: 28px;
              text-align: center;
              border-radius: 15px;
              border: 1px solid #e9e9e9;
              cursor: pointer;
            }
          }
        }
      }
    }

    .moduleStyle2 {
      .product_detail_wrap {
        position: relative;
        display: inline-block;
        overflow: visible;
        width: 100%;

        .product_img_radio {
          position: absolute;
          top: 262px;
          left: 12px;
          display: block;
          max-width: 20px;
          padding: 2px;
          width: 5%;

          .product_img_radio_item_wrap {
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;

            .product_img_radio_item {
              width: 4px;
              height: 4px;
              background: #c1c1c1;
              border-radius: 50%;
              transition: 0.2s;

              &[data-active] {
                border: 2px solid grey;
                width: 15px;
                height: 15px;
                background: 0 0;
              }
            }
          }
        }

        .product_detail_left_content {
          max-width: 700px;
          width: 50%;
          float: left;
          padding-right: 4.8%;
          margin-left: 5%;

          .detail_inner_wrap {
            margin-right: 0;

            .detail_small_pic_wrap {
              margin-top: 14px;
              position: relative;

              .jz_scroll_wrap {
                width: 100%;
                margin-left: 0;
                margin-right: 0;
                display: inline-block;

                .detail_small_pic_lists {
                  width: 100%;
                  height: 100%;
                  overflow: hidden;
                  font-size: 0;
                  white-space: nowrap;

                  .detail_small_pic_list {
                    position: relative;
                    border: 1px solid #ebebeb;
                    margin-left: 0;
                    margin-top: 36px;
                    width: 100%;
                    display: block;
                    padding: 0 0 100% 0;
                    box-sizing: border-box;

                    .position_center_middle {
                      position: absolute;
                      top: 0;
                      left: 0;
                      bottom: 0;
                      right: 0;
                      width: auto;
                      height: auto;
                      max-width: 100%;
                      max-height: 100%;
                      margin: auto;
                    }
                  }
                }
              }
            }

            .detail_pagination_wrap {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              margin: 30px 10px 0;

              .btn {
                box-sizing: border-box;
                display: inline-block;
                margin: 0 6px;
                width: 80px;
                height: 30px;
                line-height: 28px;
                text-align: center;
                border-radius: 15px;
                border: 1px solid #e9e9e9;
                cursor: pointer;
              }
            }
          }
        }

        .product_detail_right_content {
          top: 77px;
          left: 59.7828%;
          width: 40%;
          z-index: 95;
          position: absolute;
          float: left;
          background: #fff;

          .detail_title_wrap {
            display: flex;

            .detail_main_title {
              max-width: calc(100% - 80px);
              min-width: calc(100% - 80px);
              font-size: 20px;
              flex-shrink: 1;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              padding-right: 20px;
            }

            .detail_func_wrap {
              text-align: right;
              min-width: 80px;
              padding-left: 19px;
              box-sizing: border-box;

              .detail_share {
                margin-top: 6px;
                margin-right: 8px;
                display: inline-block;
                font-size: 14px;
                color: #333;
                vertical-align: middle;

                /deep/ .g-share-render-box {
                  .jz_share_text {
                    .u-icon {
                      display: block;
                      width: 40px;
                      height: 35px;
                      line-height: 20px;
                      font-size: 24px;
                      text-align: center;
                      margin: 0 !important;
                    }

                    .u-share_title {
                      display: none;
                    }
                  }

                  .jz_share_list {
                    text-align: center;

                    &::before {
                      right: 24px;
                    }
                  }
                }
              }
            }
          }

          .detail_price_wrap {
            margin-top: 35px;
            background: #f7f7f7;
            width: 100%;
            height: 100px;

            .detail_price_content {
              position: relative;

              .detail_price_left {
                padding: 30px 0 0 29px;

                .detail_price {
                  font-weight: 700;
                  color: #2b2b2b;
                  font-size: 24px;
                }
              }

              .detail_price_right {
                display: inline-block;
                position: absolute;
                right: 5%;
                bottom: 5%;

                .detail_sales {
                  display: inline-block;
                  font-size: 14px;
                  color: #666;
                }
              }
            }
          }

          .detail_other_message {
            margin: 15px 0;
            transition: margin-left 0.5s;

            .detail_other {
              line-height: 0;
              padding: 11.5px 0;
              border-bottom: 1px solid #f5f5f5;

              .detail_title {
                margin-right: 0;
                padding: 0 8px;
                width: 120px;
                display: inline-block;
                width: 72px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                font-size: 14px;
                color: #4d4d4d;
                text-align: left;
                font-weight: 700;
                margin-right: 62px;
                line-height: 30px;
                padding-left: 0;
                box-sizing: border-box;
              }

              .detail_value {
                line-height: 30px;
                display: inline-block;
                color: #666;
                font-size: 14px;
                vertical-align: top;
                width: calc(100% - 140px);
              }
            }
          }

          .product_button_wrap {
            display: flex;
            align-items: center;
            margin-top: 30px;
            padding-left: 0;

            .product_advisory_btn {
              width: 200px;
              height: 42px;
              color: #fff;
              font-size: 15px;
              line-height: 42px;
              text-align: center;
              border-radius: 21px;
              background-color: var(--theme_color);
              transition: background-color .3s;
              // cursor: pointer;
              .icon-phonenew {
                font-size: 16px;
              }
            }
          }
        }
      }

      .detail_content {
        margin-top: 6px;
        padding: 10px 10px 10px 0;
      }
    }
  }

  .view_pattern_mb {
    .product_detail_wrap {
      .detail_big_pic_content {
        position: relative;
        width: 100%;
        padding-bottom: 100%;

        img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }

      .product_detail_left_content {
        position: relative;

        .list_box {
          width: 100%;

          .detail_big_pic_content {
            position: relative;
            padding-bottom: 100%;

            .position_center_middle {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              margin: auto;
              width: auto;
              height: auto;
              max-width: 100%;
              max-height: 100%;
            }
          }
        }

        .swiper-pagination {
          position: absolute;
          bottom: 14px;
          right: 14px;
          left: auto !important;
          width: 50px;
          height: 24px;
          line-height: 24px;
          border-radius: 12px;
          text-align: center;
          background: rgba(0, 0, 0, 0.3);
          font-size: 14px;
          color: #fff;
        }
      }

      .product_detail_right_content {
        width: 100%;

        .detail_title_wrap {
          display: flex;
          align-items: center;
          margin: 10px 15px 0 15px;
          font-size: 18px;
          line-height: 26px;
          width: auto;
          color: #333;

          .detail_main_title {
            line-height: 1.2;
            width: 90%;
            padding: 0;
            min-width: calc(100% - 120px);
            padding-right: 20px;
            box-sizing: border-box;
            overflow: hidden;
            display: -webkit-box;
          }

          .detail_func_wrap {
            display: inline-block;
            border: none;
            text-align: left;
            padding: 0;
            min-width: auto;
            margin-left: 15px;

            .detail_share {
              display: inline-block;
              font-size: 14px;
              color: #333;
              vertical-align: middle;
              text-align: center;
              cursor: pointer;

              /deep/ .g-share-render-box {
                .jz_share_text {
                  .u-icon {
                    display: block;
                    width: 40px;
                    height: 35px;
                    line-height: 35px;
                    font-size: 24px;
                    text-align: center;
                    margin: 0 !important;
                  }

                  .u-share_title {
                    display: none;
                  }
                }
              }
            }
          }
        }

        .detail_summary_content {
          margin: 15px;
          word-wrap: break-word;
          line-height: 1.6;
        }

        .detail_other_message {
          margin-left: 0;
          margin-top: 16px;
          padding-top: 16px;
          background-color: #f8f8f8;

          .detail_other {
            width: 100%;
            padding: 0;
            display: flex;
            line-height: 60px;
            color: #333;
            font-size: 16px;
            background-color: #fff;
            cursor: pointer;

            .detail_other-prefix {
              width: 50px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              font-size: 14px;
              color: #999;
              margin-left: 15px;
              margin-right: 5.3%;
            }

            .detail_title {
              width: 90px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 14px;
              color: #666;
              line-height: 60px;
            }

            .detail_value {
              width: calc(100% - 140px);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              flex-grow: 1;
            }

            .detail_icon {
              display: inline-block;
              color: #999;
              margin-right: 12px;
              height: 60px;
              line-height: 60px;
              cursor: pointer;
            }
          }
        }

        .detail_other_message_mobi_wrap {
          overflow: hidden;
          position: fixed;
          bottom: 0;
          left: 0;
          height: 0;
          width: 100%;
          z-index: 99999;
          transition: 0.5s background-color, 0s 0.5s height;

          .detail_other_panel_bg {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0);
            transition: 0.5s background-color;
            cursor: pointer;
          }

          .detail_other_content {
            position: absolute;
            bottom: 0;
            height: 0;
            width: 100%;
            transition: 0.5s height;

            .detail_other_message_mobi {
              height: 100%;
              width: 100%;
              box-sizing: border-box;
              bottom: 0;
              background-color: #fff;
              padding-bottom: 50px;
              overflow-y: auto;

              .detail_other_panel_title {
                height: 60px;
                line-height: 60px;
                box-sizing: border-box;
                text-align: center;
                font-size: 16px;
              }

              .detail_other_scroll_wrap {
                width: 100%;
                overflow-y: auto;
                height: calc(100% - 60px);
                padding: 0 10px;
                box-sizing: border-box;

                .detail_other {
                  width: 100%;
                  padding: 0;
                  display: flex;
                  border-bottom: 1px solid #ebebeb;
                  font-size: 0;
                  color: #666;

                  .detail_title {
                    display: inline-block;
                    height: 55px;
                    line-height: 55px;
                    width: 90px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size: 14px;
                    color: #666;
                  }

                  .detail_value {
                    // display: inline-block;
                    vertical-align: top;
                    width: calc(100% - 90px);
                    padding-left: 2%;
                    box-sizing: border-box;
                    min-height: 50px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #666;
                    display: flex;
                    align-items: center;
                  }
                }
              }
            }

            .detail_other_message_mobi_btn {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 50px;
              line-height: 50px;
              font-size: 16px;
              color: #fff;
              text-align: center;
              background-color: var(--theme_color);
              cursor: pointer;
            }
          }

          &[data-active] {
            height: 100%;
            transition: 0.3s background-color;

            .detail_other_panel_bg {
              background-color: rgba(0, 0, 0, 0.5);
            }

            .detail_other_content {
              height: 80%;
            }
          }
        }

        .product_button_wrap {
          position: fixed;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 50px;
          z-index: 10;
          padding-left: 0;
          margin-top: 0;
          display: flex;
          align-items: center;

          .product_advisory_btn {
            flex: 1 1;
            height: 100%;
            line-height: 50px;
            width: 200px;
            color: #fff;
            font-size: 15px;
            text-align: center;
            background-color: var(--theme_color);
            transition: background-color .3s;
            cursor: pointer;
          }
        }
      }
    }
  }

}

.basic-article-info-box .view_pattern_pc .moduleStyle4 .product_detail_wrap .product_detail_right_content .detail_title_wrap .detail_main_title {
  min-width: 0;
  font-size: 20px;
  color: #333;
  white-space: normal;
  display: inline-block;
  padding-right: 20px;
}

.basic-article-info-box .view_pattern_pc .moduleStyle4 .product_detail_wrap .product_detail_right_content .detail_title_wrap .detail_func_wrap {
  border-left: 0;
  padding-left: 0;
  padding-bottom: 6px;
}

.basic-article-info-box .view_pattern_pc .moduleStyle4 .product_detail_wrap .product_detail_right_content .detail_title_wrap .detail_func_wrap .detail_share /deep/ .g-share-render-box .jz_share_text .u-share_title {
  display: none;
}

.basic-article-info-box .moduleStyle4 {
  .my-title-wrapper {
    width: 100%;
    font-size: 0;
  }

  .detail_func_wrap {
    display: inline-block;
    vertical-align: top;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_article_info/index.vue